import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: 'legacy' });

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.scss';
import './reset.scss';
import './vdlOverrides.scss';

// Load Dynatrace script dynamically
const dynatracePath = import.meta.env.VITE_DYNATRACE_PATH;
if (dynatracePath) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://js-cdn.dynatrace.com/jstag/${dynatracePath}`;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

serviceWorker.unregister();
